import * as _ from 'lodash';
import baseRequest from './baseRequest';

const ANONYMOUS_SUBMIT_URL = '/api/public/anonymous-borrowers';

export async function milestonesSubmit(values, loanType: LoanType) {
  let modelProperties: { [key: string]: any } = _.pick(values, 'loanPurpose', 'propertySearchType');

  // propertySearchType may be null if loanPurpose is REFINANCE; don't send it to the api if so
  if (modelProperties.propertySearchType === null) {
    modelProperties = _.omit(modelProperties, 'propertySearchType');
  }

  return await baseRequest.post(ANONYMOUS_SUBMIT_URL, {
    acceptTerms: values.acceptTermsAndEconsentGiven || false,
    loanType,
    modelProperties,
  });
}
